import React from 'react';
import { AlertCircle } from 'lucide-react';

const RenewableMapErrorOverlay = ({ title, children }) => (
  <div
    className="absolute inset-0 bg-red-50 bg-opacity-90 flex items-center justify-center"
    style={{ zIndex: 1000 }}
  >
    <div className="text-center max-w-xs mx-4">
      <AlertCircle className="h-8 w-8 text-red-500 mx-auto mb-2" />
      <div className="text-sm font-semibold text-red-800 mb-1">{title}</div>
      {children}
    </div>
  </div>
);

export default RenewableMapErrorOverlay;
